<template>
  <div>
    <div class="master-head master-head-buttons">
      <ul class="button-ul drop-options">
        <li class="master-head-list" @click.stop="masterHeadListClick">
          <p class="vs-con-dropdown b-dropdown-arrow" ref="masterHeadLink">
            {{currentReport}}
            <i class="list-down-arrow arrow-down"></i>
          </p>
          <div class="report-header-options" ref="masterHeadListBtn">
            <ul>
              <router-link :to="{ name: 'employee-overview' }" class="dropdown-item">
                Time Recording Overview
              </router-link>
              <router-link :to="{ name: 'vacation-report-overview' }" class="dropdown-item">
                Vacation Report Overview
              </router-link>
              <router-link :to="{ name: 'employee-time-overview' }" class="dropdown-item">
                Time Overview
              </router-link>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>


  <script>
  export default {
    data() {
    return {
    };
    },
    computed: {
      currentReport: function() {
      switch (this.$route.name) {
        case "employee-overview":
          return "Time Recording Overview";
        case "vacation-report-overview":
          return "Vacation Report Overview";
        case "employee-time-overview":
          return "Time Overview";
        default:
          return "";
      }
    }
    },
    methods: {
    /**
     * Click event handle for the dropdown
     * @param event
     */
    masterHeadListClick: function(event) {
      if (
        document.querySelector(".menu-dropdown.open-d") != undefined &&
        document.querySelector(".menu-dropdown.open-d") != null
      ) {
        document
          .querySelector(".menu-dropdown.open-d")
          .classList.remove("open-d");
      }

      if (
        event.srcElement.nextElementSibling &&
        event.srcElement.nextElementSibling.classList &&
        event.srcElement.nextElementSibling.classList.contains("r-open")
      ) {
        this.$refs.masterHeadListBtn.classList.remove("r-open");
      } else {
        if (
          this.$refs.masterHeadListBtn &&
          this.$refs.masterHeadListBtn.classList
        ) {
          this.$refs.masterHeadListBtn.classList.add("r-open");
        }
      }
    }
  },
  mounted() {
    document.body.addEventListener("click", e => {
      if (
        e.srcElement !== this.$refs.masterHeadListBtn &&
        this.$refs.masterHeadListBtn &&
        this.$refs.masterHeadListBtn.classList
      ) {
        this.$refs.masterHeadListBtn.classList.remove("r-open");
      }
    });
  },
  };
  </script>
  
  <style scoped>
  /* Report header dropdown styles */
  .master-head-list {
    position: relative;
  }
  
  .report-header-options {
    position: absolute;
    top: 30px;
    left: 0;
    height: auto;
    max-height: 0;
    width: 220px;
    background: #ffffff;
    z-index: 997;
    box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
    -moz-box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
    -webkit-box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
    overflow: hidden;
    z-index: 99999;
  }
  
  .report-header-options.r-open {
    max-height: 400px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  
  .report-header-options li {
    padding: 14px 20px;
    cursor: pointer;
  }
  
  .router-link-active span {
    position: relative;
  }
  
  .router-link-active span:after {
    content: "";
    width: 100%;
    height: 1px;
    background: #a0a0a0;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  
  /* Common export button */
  .button-export-common {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    margin-top: -2px;
  }
  
  .master-head {
    position: relative;
  }
  
  @media screen and (max-width: 1200px) {
    .master-head master-head-buttons {
      min-width: 370px;
    }
  }
  
  .master-head-buttons {
    padding-left: 0;
  }
  
  .drop-options {
    margin-left: 0;
    margin: 0 auto;
  }
  
  .vs-con-dropdown{
    font-weight:800;
  }
  
  
  </style>
  